import { starKey, StarrableEntity } from './Star.schemas';

export interface StarrableEntitiesState {
    [entitySlashId: string]: StarrableEntity;
}

export const getIsStarred = (state: StarrableEntitiesState, entity: string, id: number): boolean => {
    const key = starKey(entity, id);
    return state[key] ? state[key].isStarred : false;
};
